import { sidebarToggleOpenReducer } from '@slices/sidebar/sidebar-toggle-open';

import { appCreateSlice } from '@store/rtk';

import { SidebarState } from './types';

export const sidebarDefaultState: SidebarState = {
  isOpen: false,
};

export const sidebarSlice = appCreateSlice({
  name: 'sidebar',
  initialState: sidebarDefaultState,
  reducers: {
    sidebarToggleOpen: sidebarToggleOpenReducer,
  },
});

export const {
  actions: { sidebarToggleOpen },
  reducer: sidebarReducer,
} = sidebarSlice;
